enum ProjectInvitationBulkActionType {
  DELETE_INVITATIONS = 'deleteInvitations',
  RESEND_INVITATIONS = 'resendInvitations'
}


export { ProjectInvitationBulkActionType };